import { makeStyles } from '@mui/styles';

import { globalTheme as theme } from '@styles';

type Props = {
  small?: boolean;
  withDivider?: boolean;
};

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    gap: (props: Props) => (props.small ? theme.spacing(3) : theme.spacing(2)),
    borderBottom: ({ withDivider }: Props) =>
      withDivider ? `1px solid ${theme.palette.brandGray.light}` : 0,
    [theme.breakpoints.up('md')]: {
      flexDirection: 'column' as const,
      gap: theme.spacing(1),
      borderRight: ({ withDivider }: Props) =>
        withDivider ? `1px solid ${theme.palette.brandGray.light}` : 0,
      borderBottom: '0!important',
      padding: `0 ${theme.spacing(3)}px`,
    },
    justifyContent: 'space-between',
    padding: theme.spacing(2),
  },
  iconContainer: {
    '& img': {
      height: 64,
      width: 64,
    },
    [theme.breakpoints.up('md')]: {
      textAlign: 'center',
    },
  },
  content: {
    whiteSpace: (props: Props) => (props.small ? 'normal' : 'pre-line'),
    width: '100%',
  },
  divider: {
    width: '100%',
    height: '1px',
    backgroundColor: theme.palette.brandGray.light,
  },
  header: {
    fontSize: (props: Props) => (props.small ? 18 : undefined),
    [theme.breakpoints.up('md')]: {
      textAlign: 'center' as const,
    },
  },
}));
